import { createContext, PropsWithChildren } from 'react'

export const IsInArcadeModalContext = createContext(false)
export const ArcadeModalContentElementContext = createContext<HTMLElement | null>(null)

export const ArcadeModalContextProvider = ({
  children,
  contentElement = null,
}: PropsWithChildren<{ contentElement?: HTMLElement | null }>) => (
  <IsInArcadeModalContext.Provider value={true}>
    <ArcadeModalContentElementContext.Provider value={contentElement}>
      {children}
    </ArcadeModalContentElementContext.Provider>
  </IsInArcadeModalContext.Provider>
)
